module["exports"] = [
  "worldlink.com.np",
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/internet/free_email.js
// module id = 1401
// module chunks = 0